import type { GetDashboardAlertsResult } from '@features/home/api/get-dashboard-alerts/getDashboardAlerts.types';
import type { UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@contexts/auth-provider/hooks/use-auth/useAuth';
import { useOrganizations } from '@contexts/organizations-provider';
import { getDashboardAlerts } from '@features/home/api/get-dashboard-alerts/getDashboardAlerts';
import { useQuery } from '@tanstack/react-query';

export function useDashboardAlerts(options?: {
  enabled?: boolean;
}): UseQueryResult<GetDashboardAlertsResult, Error> {
  const { isAuthenticated } = useAuth();
  const { selectedOrganization } = useOrganizations();
  const organizationId = selectedOrganization?.id ?? '';

  return useQuery<GetDashboardAlertsResult, Error>({
    queryKey: ['dashboard', 'alerts', organizationId],
    queryFn: () => getDashboardAlerts({ organizationId }),
    enabled:
      isAuthenticated && !!selectedOrganization && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
